module.exports = __webpack_public_path__ + "static/media/emojis_11.aa6b95c1.svg";